import React, { useEffect } from "react";
import Messages from "./Messages";
import { setShowChat } from "../../store/actions";
import { connect } from "react-redux";
import { Tooltip } from "react-tooltip";
import NewMessage from "./NewMessage";


const PopupMessages = (props) => {
  const { setShowChatAction } = props;


  useEffect(() => {
    // Add class to body so CSS can hide the meeting timer on mobile
    document.body.classList.add("chat-panel-open");
    return () => {
      document.body.classList.remove("chat-panel-open");
    };
  }, []);


  const closeDiv = () => {
    setShowChatAction(false);
  };


  return (
    <div className="participants_popup_container open">
      <Tooltip id="my-tooltip" />
      <div className="chat-popup-header">
        <p className="chat-popup-title">In-call Messages</p>
        <span
          className="chat-popup-close-btn"
          onClick={closeDiv}
          data-tooltip-id="my-tooltip"
          data-tooltip-content="Close"
        >
          ×
        </span>
      </div>
      <div className="chat-popup-body">
        <Messages />
        <NewMessage />
      </div>
    </div>
  );
};


const mapActionsToProps = (dispatch) => {
  return {
    setShowChatAction: (showChat) => dispatch(setShowChat(showChat)),
  };
};


export default connect(null, mapActionsToProps)(PopupMessages);

